/**
 * @generated SignedSource<<f8f7448c35419012bcfab66c3b656caa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "Refresh",
    "kind": "LinkedField",
    "name": "refreshToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "authApiService_refreshTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "authApiService_refreshTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "331b3ed5df6c7f72f831380ca0f8e422",
    "id": null,
    "metadata": {},
    "name": "authApiService_refreshTokenMutation",
    "operationKind": "mutation",
    "text": "mutation authApiService_refreshTokenMutation(\n  $token: String!\n) {\n  refreshToken(token: $token) {\n    token\n  }\n}\n"
  }
};
})();

node.hash = "bc15a916e79d314ca9e91b52136b3bd7";

module.exports = node;
